import React from 'react';
import { FaStar } from 'react-icons/fa';

const testimonials = [
  {
    name: 'Srijani Debnath',
    institution: 'Government College of Engineering & Leather Technology, Kolkata',
    stars: 4,
    feedback: 'The Training and Mentorship Part of This Program Was Quite Good.',
  },
  {
    name: 'Smit Kagathara',
    institution: 'LDRP-ITR (Gandhinagar, Gujarat), Computer Engineering',
    stars: 5,
    feedback: 'I Think That InternsElite has a Wonderful Agenda by Training People with a Variety of Courses and The Sessions Were Extraordinary and Very Helpful.',
  },
  {
    name: 'Minakshi Kumari',
    institution: 'Chandigarh Group of Colleges, Btech',
    stars: 4,
    feedback: 'Very good training. There were experts who gave us so much knowledge, and I learned a lot. Kiran Mam is the best teacher I have ever seen, and Ayan Sir was also very nice to me.',
  },
  {
    name: 'Prathamesh Omprakash Khairnar',
    institution: 'KBTCOE, Information Technology',
    stars: 4,
    feedback: 'It was a very nice experience with this course, and I gained very much essential knowledge from this, thanks to the team.',
  },
  {
    name: 'Prashant Kumar',
    institution: 'G.L. Bajaj Institute of Technology and Management, Civil Engineering Department',
    stars: 5,
    feedback: 'I have had a great experience learning with this internship. The tutors were really helpful and approachable. I would like to thank you for giving me this opportunity to learn and skill my level up.',
  },
  {
    name: 'Gagan Deep K',
    institution: 'VVIT, CSE',
    stars: 4,
    feedback: 'It was a very good experience training in the company, which helped me improve my skills and knowledge. The company provided very good knowledge in the field of training and about new technology in the professional field.',
  },
];

function MLP_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Says</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {testimonials.map((testimonial, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? 5 : 7} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{testimonial.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{testimonial.institution}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {Array.from({ length: 5 }, (_, i) => (
                          <li key={i}>
                            <FaStar color={i < testimonial.stars ? 'gold' : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className='mb-2 Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{testimonial.feedback}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MLP_Review_Program_Page;
